// 9fbef606107a605d69c0edbcd8029e5d 
export default {
  MODAL_COL_DEFAULTS: {
    small: 6,
    medium: 6,
    large: 8,
  },
};
